/* eslint-disable no-console */
'use strict';
try {
    const DEBUG_MODE = process.env.VITE_ENV !== 'production' || localStorage.getItem('DEBUG_MODE') === 'true';
    if (!DEBUG_MODE && window.console && console) {
        const consoleHolder = {};
        Object.keys(console).forEach(method => {
            consoleHolder[method] = console[method];
            console[method] = function (..._args) {
                // Do nothing.
                // This 👇 is here for reference
                // if (DEBUG_MODE) {
                //     consoleHolder[method](...args);
                // }
            };
        });
    }
} catch (e) {
    console.error('Error wrapping console object', e);
}
